import './style.sass';
import 'select2';

const maxHeight = 180;
// Примерная ширина одного символа в пикселях
const approxCharWidth = 9;
// Ширина текта мультиселекта по умолчинию в пикселях
const mSelectInnerWidth = 247;
// Колличество символов обрезки под спецсимволы
const rmCharsOnTruncate = 3;
// Максимальное колличество символов в мультиселекте
let mSelectionMaxLen = 0;

export default function eachBox(boxIndex, Boxlement, { runOnSelect } = {}) {
    const $box = $(Boxlement);
    const $select = $box.find('select');
    let $input = null;

    if ($box.hasClass('select-box-init')) {
        return true;
    }

    $box.addClass('select-box-init');

    const minSelector = $select.data('min-selector');
    const maxSelector = $select.data('max-selector');
    let isMultiple = $select.attr('multiple') || $select.data('multiple');
    isMultiple = typeof isMultiple !== 'undefined' && !!isMultiple;

    const $min = minSelector && $(minSelector);
    const $max = maxSelector && $(maxSelector);

    const hasMinPair = minSelector && $min.length;
    const hasMaxPair = maxSelector && $max.length;

    const $pairSelect = hasMaxPair ? $max : $min;

    if ($select.hasClass('select2-hidden-accessible')) {
        return true;
    }

    const options = {
        placeholder: $select.data('placeholder') || null,
        width: $select.data('width') || '100%' || 'style',
        theme: $select.data('theme') || 'nlmk',
        minimumResultsForSearch: Infinity,
        dropdownParent: $box,
        closeOnSelect: !isMultiple, // Не закрываем при выборе опции, если множественный
    };

    $select
        .select2(options)
        .on('select2:open', onOpen)
        .on('select2:close', onClose);

    $box.addClass('ready');

    if (hasMinPair || hasMaxPair) {
        $select.on('runOnSelect select2:select', onSelect);

        if (!$pairSelect.data('pair-onSelect-done')) {
            $pairSelect.data('pair-onSelect-done', true).trigger('runOnSelect');
        }
    }

    $box.find('.form-label').on('click', function () {
        const $select2 = $box.find('.select2');

        if (!$select2.hasClass('select2-container--disabled')) {
            if ($select2.hasClass('select2-container--open')) {
                $select.select2('close');
            } else {
                $select.select2('open');
            }
        }
    });

    setTimeout(function () {
        $input = $box.find('.select2-container').find('.select2-search__field');

        handleSelection();
        $(window).on('multiselect-truncate-refresh', handleSelection);
        $select.on('select2:select select2:unselect', handleSelection);
    }, 300);

    function handleSelection() {
        const val = $select.val();

        if (typeof val !== 'undefined' && !!val && !!val.length) {
            $select.addClass('filled-out');
        } else {
            $select.removeClass('filled-out');
        }

        if (isMultiple) {
            mSelectionMaxLen = Math.floor(($input.innerWidth() || mSelectInnerWidth) / approxCharWidth);
            const data = getSelectedData();

            if (mSelectionMaxLen < data.str.length) {
                data.str = `${data.str.substring(0, mSelectionMaxLen - rmCharsOnTruncate)}... (${data.count})`;
            }

            if (!data.str) {
                $select.val(null).trigger('change');

                if ($input.hasClass('placeholder--dark')) {
                    $input.removeClass('placeholder--dark');
                }
            } else {
                if (!$input.hasClass('placeholder--dark')) {
                    $input.addClass('placeholder--dark');
                }

                $input.attr('placeholder', data.str);
            }
        }
    }

    function getSelectedData() {
        const data = {
            str: '',
            count: 0,
        };

        $select.find(':selected').each(function () {
            const text = $(this).text();

            if (!!text && $(this).val() !== 'all') {
                if (!!data.str) {
                    data.str += `, ${text}`;
                } else {
                    data.str = text;
                }

                data.count++;
            }
        });

        return data;
    }

    function onSelect() {
        const $pairOptions = $pairSelect.children();

        let pairOptions = $pairSelect.data('options');

        if (!pairOptions) {
            pairOptions = Array.from($pairOptions).sort(sortOptionsByValue);

            $pairSelect.data('options', pairOptions);
        }

        const currentValue = parseFloat($select.val());
        const currentPairValue = parseFloat($pairSelect.val());

        const filteredPairOptions = [];

        const maxComparator = (current, variant) => current <= variant;
        const minComparator = (current, variant) => current >= variant;

        const comparator = hasMaxPair ? maxComparator : minComparator;

        pairOptions.forEach((pairOption) => {
            const pairOptionValue = parseFloat(pairOption.value);

            if (comparator(currentValue, pairOptionValue)) {
                if (pairOption.value) {
                    const selected = currentPairValue === pairOptionValue;

                    const CleanOption = new Option(pairOption.text, pairOption.value, selected, selected);

                    filteredPairOptions.push(CleanOption);
                }
            }
        });

        let correctedPairValue = null;

        if (hasMaxPair && currentValue <= currentPairValue) {
            correctedPairValue = currentPairValue;
        } else if (hasMinPair && currentValue >= currentPairValue) {
            correctedPairValue = currentPairValue;
        }

        $pairSelect
            .empty()
            .append(filteredPairOptions)
            .val(correctedPairValue)
            .off('select2:select')
            .off('select2:open')
            .select2('destroy')
            .removeClass('select2-hidden-accessible');

        $pairSelect
            .children()
            .prop('selected', false)
            .removeAttr('selected')
            .filter(`[value="${correctedPairValue}"]`)
            .prop('selected', true);

        const $pairSelectBox = $pairSelect.closest('.select-box');

        $pairSelectBox.removeClass('select-box-init');

        eachBox(0, $pairSelectBox.get(0), { runOnSelect: true });
    }

    function onOpen() {
        setTimeout(function() {
            const $selectOptions = $box.find('.select2-results__options');
            const $selectDropdown = $box.find('.select2-dropdown');

            if (isMultiple && !$selectDropdown.find('.select2-dropdown__bottom').length) {
                const btnText = LANG === 'ru' ? 'применить' : 'apply';

                $selectDropdown.append(`
                        <div class="select2-dropdown__bottom">
                            <button class="btn-v2 btn-v2--no-arrow btn-v2--responsive js-selection-apply">${btnText}</button>
                        </div>
                    `);

                $('.js-selection-apply').on('click', function () {
                    $select.select2('close');
                });
            }

            if ($selectOptions.height() > maxHeight) {
                $selectDropdown.height(maxHeight);

                var temp = $selectOptions
                    .addClass('nano-content')
                    .parent()
                    .addClass('nano')
                    .nanoScroller({
                        alwaysVisible: true,
                        sliderMinHeight: 50
                    });

                // если хочу изменить дату, то самый минимальный год 1950 сверху начинает отображаться
                if ($selectOptions.find('[aria-selected=true]').length > 0) {
                    const positionY = $selectOptions.find('[aria-selected=true]').eq(0).position().top;
                    temp.nanoScroller({
                        scrollTop: parseInt(positionY)
                    });
                }

                // Добавление отступов, соответствующих паддингам, сверху и снизу слайдера
                const $nanoSlider = $box.find('.nano-slider');

                if ($nanoSlider.data('corrected')) {
                    return;
                }

                const $nanoPane = $box.find('.nano-pane');
                const vPadding = parseInt($nanoPane.css('padding-top')) + parseInt($nanoPane.css('padding-bottom'));

                $nanoSlider.css('height', `${parseInt($nanoSlider.css('height')) - vPadding}px`);
                $nanoSlider.data('corrected', true);
            }
        }, 0);
    }

    function onClose() {
        if (isMultiple) {
            setTimeout(function () {
                $input.blur();
            }, 100);
        }
    }
}

/**
 *
 * @param {HTMLOptionElement} a
 * @param {HTMLOptionElement} b
 * @returns {number}
 */
function sortOptionsByValue(a, b) {
    a = parseFloat(a.value);
    b = parseFloat(b.value);

    return b < a ? 1 : b === a ? 0 : -1;
}



// WEBPACK FOOTER //
// ./js/main/module/select/init.js